/*
 * @Description: 专家预约记录方法
 * @Author: 钱磊
 * @Date: 2022-04-06 16:25:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-10-08 09:36:41
 */
import request from '../request.js'

// 条件查询专家预约记录 ---- 张卫华
export const getExpertsRecordsReplyPageList = function (data) {
    return request({
        url: 'bmExpert/getReplyRecords',
        method: 'post',
        data
    })
}
// 查询专家预约记录详情 ---- 张卫华
export const getExpertsRecordsReplyDetail = function (data) {
    return request({
        url: 'bmExpert/getReplyDetails',
        method: 'post',
        data
    })
}
// 查询专家预约记录抽取回复详情 ---- 张卫华
export const getExpertsReplyPageList = function (data) {
    return request({
        url: 'bmExpert/getReplyPageList',
        method: 'post',
        data
    })
}
// 根据规则id获取规则信息 ---- 张卫华
export const getRuleInfoByRuleId = function (data) {
    return request({
        url: 'bmExpert/getRuleInfoByRuleId',
        method: 'post',
        data
    })
}

// 条件查询专家预约记录新 ---- 高进
export const getExpertsRecordsReplyPageListNew = function (data) {
    return request({
        url: 'ngsExpert/getReplyRecords',
        method: 'post',
        data
    })
}
// 查询专家预约记录详情新 ---- 高进
export const getExpertsRecordsReplyDetailNew = function (data) {
    return request({
        url: 'ngsExpert/getReplyDetails',
        method: 'post',
        data
    })
}
// 查询专家预约记录抽取回复详情新 ---- 高进
export const getExpertsReplyPageListNew = function (data) {
    return request({
        url: 'ngsExpert/getReplyPageList',
        method: 'post',
        data
    })
}

